import { render } from "./OcrUploadCard.vue?vue&type=template&id=a2608168&scoped=true"
import script from "./OcrUploadCard.vue?vue&type=script&lang=js"
export * from "./OcrUploadCard.vue?vue&type=script&lang=js"

import "./OcrUploadCard.vue?vue&type=style&index=0&id=a2608168&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2608168"]])

export default __exports__